<template>
  <div :class="`${component.type}-container`">
    <!-- Dynamically render the component based on component.type -->
    <component :is="componentEditor" :component="component" :theme="theme[component.type]" :is-global-content-item="isGlobalContentItem"></component>
  </div>
</template>

<script>
import HeadlineContentItemEditor from './Headline/HeadlineEditor/HeadlineEditor.vue'
import TextContentItemEditor from './Text/TextEditor/TextEditor.vue'
import SpacerContentItemEditor from './Spacer/SpacerEditor/SpacerEditor.vue'
import FieldContentItemEditor from './Field/FieldEditor/FieldEditor.vue'
import ButtonContentItemEditor from './Button/ButtonEditor/ButtonEditor.vue'
import ImageContentItemEditor from './Image/ImageEditor/ImageEditor.vue'
import RankContentItemEditor from './Rank/RankEditor/RankEditor.vue'
import SocialContentItemEditor from './Social/SocialEditor/SocialEditor.vue'
import SurveyContentItemEditor from './Survey/SurveyEditor/SurveyEditor.vue'
import FortuneWheelContentItemEditor from './FortuneWheel/FortuneWheelEditor/FortuneWheelEditor.vue'
import VoucherContentItemEditor from './Voucher/VoucherEditor/VoucherEditor.vue'
import CheckboxContentItemEditor from './Checkbox/CheckboxEditor/CheckboxEditor.vue'

export default {
  name: 'ContentItemEditorContainerComponent',
  props: {
    component: {
      type: Object,
      required: true,
    },
    theme: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    isGlobalContentItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    componentEditor() {
      // Mapping of component types to component definitions
      const editorMap = {
        headline: HeadlineContentItemEditor,
        text: TextContentItemEditor,
        spacer: SpacerContentItemEditor,
        field: FieldContentItemEditor,
        button: ButtonContentItemEditor,
        image: ImageContentItemEditor,
        rank: RankContentItemEditor,
        social: SocialContentItemEditor,
        survey: SurveyContentItemEditor,
        wheel: FortuneWheelContentItemEditor,
        voucher: VoucherContentItemEditor,
        checkbox: CheckboxContentItemEditor,
      };

      return editorMap[this.component?.type] || null;
    },
  },
}
</script>